import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  private readonly _document = inject<Document>(DOCUMENT);

  constructor() {
    this.setBrowserTab();
    this.SetColours();
  }

  SetColours() {

    document.documentElement.style.setProperty(
      '--primary',
      environment.ColorConfig.primary
    );

    document.documentElement.style.setProperty(
      '--secondary',
      environment.ColorConfig.secondary
    );

    document.documentElement.style.setProperty(
      '--header-background',
      environment.ColorConfig.headerBackground
    );

    document.documentElement.style.setProperty(
      '--hero-gradient',
      environment.ColorConfig.heroGradient
    );

    document.documentElement.style.setProperty(
      '--header-scroll',
      environment.ColorConfig.headerScroll
    );

    document.documentElement.style.setProperty(
      '--contact-card',
      environment.ColorConfig.contactCard
    );

    document.documentElement.style.setProperty(
      '--background',
      environment.ColorConfig.background
    );

    document.documentElement.style.setProperty(
      '--text',
      environment.ColorConfig.text
    );

    document.documentElement.style.setProperty(
      '--light-grey',
      environment.ColorConfig.lightGrey
    );

    document.documentElement.style.setProperty(
      '--heading-font',
      environment.ColorConfig.headingFont
    );

    document.documentElement.style.setProperty(
      '--shadow',
      environment.ColorConfig.shadow
    );

    document.documentElement.style.setProperty(
      '--radius',
      environment.ColorConfig.radius
    );

    document.documentElement.style.setProperty(
      '--dark',
      environment.ColorConfig.dark
    );

    document.documentElement.style.setProperty(
      '--input-fields',
      environment.ColorConfig.inputFields
    );

    document.documentElement.style.setProperty(
      '--input-fields-box-shadow',
      environment.ColorConfig.inputFieldsBoxShadow
    );

    document.documentElement.style.setProperty(
      '--error-message',
      environment.ColorConfig.errorMessage
    );
    document.documentElement.style.setProperty(
      '--review-star',
      environment.ColorConfig.reviewStar
    );

    document.documentElement.style.setProperty(
      '--caption-background',
      environment.ColorConfig.captionBackground
    );
  }

  setBrowserTab(): void {
    this._document.getElementById('favicon')?.setAttribute('href', environment.AppConfig.Icon);
    this._document.title = environment.FooterConfig.brandName;
  }

}
